export const gmap = [
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#d3d3d3"
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "color": "#808080"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#b3b3b3"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "weight": 1.8
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#d7d7d7"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ebebeb"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#a7a7a7"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#efefef"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#696969"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#737373"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#d6d6d6"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {},
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#dadada"
            }
        ]
    }
]

export const storeIcon = {
  path: "M18.4481 0.11956C14.3594 0.561584 10.3149 2.32968 7.2428 5.07023C4.72326 7.30245 2.71205 10.264 1.62909 13.3803C-0.44842 19.3918 0.347223 25.5801 4.01602 31.7464C5.60731 34.4206 7.72902 37.0949 12.2377 42.1339C16.017 46.3774 18.7354 49.7146 19.9068 51.5932C20.393 52.3447 20.5919 52.3447 21.1002 51.5711C21.6528 50.7092 23.885 47.7697 25.1006 46.3332C25.7415 45.5817 27.4433 43.6147 28.9241 41.935C32.9907 37.3601 34.5157 35.4815 36.1291 33.0503C41.0797 25.6464 41.8533 17.911 38.3171 10.9712C36.328 7.08144 33.3443 4.11988 29.4545 2.15287C25.9846 0.428977 22.2274 -0.278261 18.4481 0.11956Z",
  fillColor: '#ffffff',
  fillOpacity: 1,
  strokeColor: '#000000',
  strokeWeight: 1,
  scale: .50
}

export const showroomIcon = {
    path: "M18.4481 0.11956C14.3594 0.561584 10.3149 2.32968 7.2428 5.07023C4.72326 7.30245 2.71205 10.264 1.62909 13.3803C-0.44842 19.3918 0.347223 25.5801 4.01602 31.7464C5.60731 34.4206 7.72902 37.0949 12.2377 42.1339C16.017 46.3774 18.7354 49.7146 19.9068 51.5932C20.393 52.3447 20.5919 52.3447 21.1002 51.5711C21.6528 50.7092 23.885 47.7697 25.1006 46.3332C25.7415 45.5817 27.4433 43.6147 28.9241 41.935C32.9907 37.3601 34.5157 35.4815 36.1291 33.0503C41.0797 25.6464 41.8533 17.911 38.3171 10.9712C36.328 7.08144 33.3443 4.11988 29.4545 2.15287C25.9846 0.428977 22.2274 -0.278261 18.4481 0.11956Z",
  fillColor: '#000000',
  fillOpacity: 1,
  strokeColor: '#000000',
  strokeWeight: 1,
  scale: .50
}

export const headquarterIcon = {
    path: "M18.4481 0.11956C14.3594 0.561584 10.3149 2.32968 7.2428 5.07023C4.72326 7.30245 2.71205 10.264 1.62909 13.3803C-0.44842 19.3918 0.347223 25.5801 4.01602 31.7464C5.60731 34.4206 7.72902 37.0949 12.2377 42.1339C16.017 46.3774 18.7354 49.7146 19.9068 51.5932C20.393 52.3447 20.5919 52.3447 21.1002 51.5711C21.6528 50.7092 23.885 47.7697 25.1006 46.3332C25.7415 45.5817 27.4433 43.6147 28.9241 41.935C32.9907 37.3601 34.5157 35.4815 36.1291 33.0503C41.0797 25.6464 41.8533 17.911 38.3171 10.9712C36.328 7.08144 33.3443 4.11988 29.4545 2.15287C25.9846 0.428977 22.2274 -0.278261 18.4481 0.11956Z",
  fillColor: '#CCCCCC',
  fillOpacity: 1,
  strokeColor: '#CCCCCC',
  strokeWeight: 1,
  scale: .50
}

export const mainStoreIcon = {
    path: "M29.8561 0.139487C25.086 0.655181 20.3674 2.71796 16.7833 5.91527C13.8438 8.51952 11.4974 11.9747 10.2339 15.6103C7.81018 22.6238 8.73843 29.8435 13.0187 37.0375C14.8752 40.1574 17.3505 43.2774 22.6107 49.1562C27.0198 54.107 30.1913 58.0004 31.5579 60.1921C32.1252 61.0688 32.3572 61.0688 32.9502 60.1663C33.5949 59.1607 36.1992 55.7313 37.6174 54.0554C38.3651 53.1786 40.3505 50.8838 42.0781 48.9242C46.8225 43.5868 48.6017 41.3951 50.484 38.5587C56.2597 29.9208 57.1622 20.8962 53.0366 12.7997C50.716 8.26168 47.235 4.80653 42.6969 2.51168C38.6487 0.500473 34.2653 -0.324638 29.8561 0.139487Z M32.135 24.086L35.428 23.531L40.904 33.299C41.0767 33.595 41.274 33.817 41.496 33.965C41.7427 34.113 42.0263 34.2117 42.347 34.261C42.6923 34.3103 43.0623 34.335 43.457 34.335H43.79V36H38.351L32.135 24.086ZM27.547 33.965C27.547 34.039 27.6333 34.1007 27.806 34.15C27.9787 34.1747 28.2007 34.2117 28.472 34.261C28.768 34.2857 29.0763 34.3103 29.397 34.335C29.7423 34.335 30.0753 34.335 30.396 34.335H30.877V36H20.628V34.335H20.998C21.886 34.335 22.626 34.2487 23.218 34.076C23.81 33.9033 24.106 33.5457 24.106 33.003V12.727C24.106 12.1843 23.81 11.8267 23.218 11.654C22.626 11.4813 21.886 11.395 20.998 11.395H20.628V9.73H31.247C33.245 9.73 34.947 10.0507 36.353 10.692C37.7837 11.3087 38.8813 12.1843 39.646 13.319C40.4107 14.429 40.793 15.7363 40.793 17.241C40.793 18.4497 40.5217 19.5473 39.979 20.534C39.461 21.496 38.7087 22.31 37.722 22.976C36.76 23.642 35.6007 24.123 34.244 24.419C33.9233 24.493 33.5903 24.5547 33.245 24.604C32.8997 24.6533 32.542 24.6903 32.172 24.715C31.802 24.7397 31.4197 24.752 31.025 24.752H26.807V22.828H31.025C32.431 22.828 33.578 22.606 34.466 22.162C35.3787 21.6933 36.0447 21.0397 36.464 20.201C36.8833 19.3623 37.093 18.3757 37.093 17.241C37.093 16.1063 36.871 15.132 36.427 14.318C35.983 13.504 35.317 12.8873 34.429 12.468C33.5657 12.024 32.4803 11.802 31.173 11.802H27.547V33.965Z",
  fillColor: 'black',
  fillOpacity: 1,
  strokeColor: 'white',
  strokeWeight: 0,
  scale: .45
}
